'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = 'M144 16l96 0 0-16-112 0 0 272-89.6 67.2c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96 15.4 0 30.5-3.7 44-10.7-3.2-4.3-6.1-8.8-8.8-13.5-10.9 5.3-22.9 8.2-35.2 8.2-44.2 0-80-35.8-80-80 0-25.2 11.9-48.9 32-64l0 0 89.6-67.2 6.4-4.8 0-168 96 0 0-16-96 0 0-80zm160 96l160 0 0 248-160 120c-13.8 10.4-30.7 16-48 16-44.2 0-80-35.8-80-80 0-25.2 11.9-48.9 32-64l89.6-67.2 6.4-4.8 0-168zM288 272l-89.6 67.2c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2L480 368 480 0 288 0 288 272zM304 96l0-80 160 0 0 80-160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;